var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count > 0)?_c('span',{staticClass:"chat-unread-badge",class:_vm.sizeClass},[_vm._v(" "+_vm._s(_vm.displayCount)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }